import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  losUrl: string = '';

  loggedIn = false;

  constructor(public userService: UserService, private router: Router) {
  }

  ngOnInit(): void {
    this.loggedIn = this.userService.loggedIn();
    this.userService.subscribe((e: any) => {
      this.loggedIn = this.userService.loggedIn();
    });
  }


}
